export default "__VITE_ASSET__z6WM539j__"